import ViewHolidays from './ViewHolidaysContainer';

export default ViewHolidays;
